import React, { ComponentPropsWithoutRef } from "react";

interface StackProps extends ComponentPropsWithoutRef<"div"> {
    align?: "center" | "flex-end" | "flex-start" | "stretch" | "baseline";
    gap?: number;
    justify?: "center" | "flex-end" | "flex-start" | "space-between" | "space-around" | "space-evenly";
    grow?: number;
}

const Stack: React.FC<StackProps> = ({ align, gap, justify, style, grow, ...otherProps }) => {
    return (
        <div
            {...otherProps}
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: align,
                gap,
                justifyContent: justify,
                flexGrow: grow,
                ...style,
            }}
        />
    );
};

export default Stack;
